import React from 'react'
import dayjs from 'dayjs'
import {
    Button,
    DateField,
    IconButton,
    RadioGroup,
    Typogaphy,
} from 'vnetwork-ui'
import DeleteOutlineIcons from '@/icons/DeleteOutlineIcons'
import { BUSINESS_OPTION } from '@/modules/Business/types/utils'
import { useTranslation } from 'react-i18next'
import AddIcons from '@/icons/AddIcons'

export interface TimeEntry {
    date: string
    option: string
}

interface TimeEntriesProps {
    timeEntries: TimeEntry[]
    setTimeEntries: React.Dispatch<React.SetStateAction<TimeEntry[]>>
    handleAddDay: () => void
    minDate?: dayjs.Dayjs
}

const BusinessTimer: React.FC<TimeEntriesProps> = ({
    timeEntries,
    setTimeEntries,
    handleAddDay,
    minDate,
}) => {
    const handleDateChange = (index: number, newDate: string) => {
        const newEntries = [...timeEntries]
        newEntries[index].date = newDate
        setTimeEntries(newEntries)
    }

    const handleDelete = (index: number) => {
        const newEntries = timeEntries.filter((_, i) => i !== index)
        setTimeEntries(newEntries)
    }
    const { t } = useTranslation('business')
    return (
        <div className="grid grid-cols-1 md:grid-cols-8 gap-4">
            <div className="col-span-1">
                <Typogaphy size="small">
                    {t('business-startdate-label')}
                </Typogaphy>
            </div>
            {timeEntries.length > 0 &&
                timeEntries?.map((entry, index) => (
                    <React.Fragment key={index}>
                        {index !== 0 && <div className="md:col-span-1" />}
                        <div className="col-span-3">
                            <DateField
                                label={`${t('day')} ${index + 1}`}
                                value={dayjs(entry.date)}
                                minDate={minDate}
                                onChange={(e) =>
                                    handleDateChange(
                                        index,
                                        e?.format('YYYY-MM-DDTHH:mm:ss') ||
                                            entry.date
                                    )
                                }
                            />
                        </div>

                        <div
                            id="day_option"
                            className="col-span-1 md:col-span-4"
                        >
                            <div className="flex justify-between flex-1">
                                <RadioGroup
                                    value={entry.option}
                                    direction="row"
                                    options={BUSINESS_OPTION(t)}
                                    size="small"
                                    onChange={(value) => {
                                        const newEntries = [...timeEntries]
                                        newEntries[index].option =
                                            value as string
                                        setTimeEntries(newEntries)
                                    }}
                                />
                                {timeEntries.length > 1 && (
                                    <IconButton
                                        size="small"
                                        color="error"
                                        className="border hover:border-c-error hover:text-c-error"
                                        onClick={() => handleDelete(index)}
                                    >
                                        <DeleteOutlineIcons className="text-c-error w-4 h-4" />
                                    </IconButton>
                                )}
                            </div>
                        </div>
                    </React.Fragment>
                ))}

            <div className="md:col-span-1" />
            <div className="col-span-1 md:col-span-7">
                <Button
                    size="small"
                    type="button"
                    onClick={handleAddDay}
                    className="w-full !bg-[#F9FBFF]"
                    startIcon={<AddIcons className="text-primary" />}
                ></Button>
            </div>
        </div>
    )
}

export default BusinessTimer
